import Route from '@/Enums/Routes/Route.enum';
import ScreenKey from '@/Enums/Screens/ScreenKey.enum';

export const ROUTE_LABELS: Record<
  Exclude<Route, Route.SET_NEW_PASSWORD | Route.FORGOT_PASSWORD | Route.LOGIN | Route.SSO>,
  string
> = {
  [Route.REPORTING_DASHBOARD]: 'Reporting',
  [Route.REPORTING_V2]: 'Unified Reporting',
  [Route.CUSTOM_DASHBOARDS]: 'Custom Dashboards',
  [Route.CUSTOM_DASHBOARD_DETAIL]: 'Custom Dashboards',
  [Route.FORECASTER]: 'Forecaster',
  [Route.CREATE_CAMPAIGN]: 'Create Campaign',
  [Route.FORECASTER_TABLE]: 'Forecaster',
  [Route.FORECASTER_AI]: 'Forecaster',
  [Route.CAMPAIGN_SUBMISSION]: 'Campaign Submission',
  [Route.CAMPAIGN_MANAGEMENT]: 'Campaign Management',
  [Route.CREATIVE_LIBRARY]: 'Creative Library',
  [Route.USER_MANAGEMENT]: 'User Management',
  [Route.PACING]: 'Pacing',
  [Route.PIXELS]: 'Pixels',
  [Route.SETTINGS]: 'Settings',
  [Route.WHITELABELS]: 'Whitelabels',
  [Route.ADVERTISERS]: 'Advertisers',
  [Route.AGENCIES]: 'Agencies',
  [Route.FIRST_PARTY_DATA]: 'First Party Data Upload',
  [Route.CHANGE_LOG_HISTORY]: 'Change Log History',
  [Route.REPORT_BUILDER]: 'Report Builder',
  [Route.CLIENTS]: 'Clients',
  [Route.INSIGHTS]: 'Insights',
  [Route.SEGMENTS]: 'Segments',
  [Route.PDF_BUILDER]: 'PDF Builder',
  [Route.PARTNER_DATA_HEALTH]: 'Partner Data Health',
};

export const SCREEN_LABELS: Record<ScreenKey, string> = {
  [ScreenKey.REPORTING_DASHBOARD]: 'Reporting Dashboard',
  [ScreenKey.REPORTING_V2]: 'Unified Reporting',
  [ScreenKey.CUSTOM_DASHBOARDS]: 'Custom Dashboards',
  [ScreenKey.REPORT_BUILDER]: 'Report Builder',
  [ScreenKey.PACING]: 'Pacing',
  [ScreenKey.PIXELS]: 'Pixels',
  [ScreenKey.FORECASTER]: 'Forecaster',
  [ScreenKey.FORECASTER_TABLE]: 'Forecaster',
  [ScreenKey.FORECASTER_AI]: 'Forecaster AI',
  [ScreenKey.CAMPAIGN_MANAGEMENT]: 'Campaign Management',
  [ScreenKey.CAMPAIGN_SUBMISSION]: 'Campaign Submission',
  [ScreenKey.CREATIVE_LIBRARY]: 'Creative Library',
  [ScreenKey.CREATE_CAMPAIGN]: 'Create Campaign',
  [ScreenKey.CLIENTS]: 'Client',
  [ScreenKey.ADVERTISERS]: 'Advertiser',
  [ScreenKey.USER_MANAGEMENT]: 'User Management',
  [ScreenKey.WHITELABELS]: 'Whitelabels',
  [ScreenKey.AGENCIES]: 'Agencies',
  [ScreenKey.FIRST_PARTY_DATA]: 'First Party Data Upload',
  [ScreenKey.CHANGE_LOG_HISTORY]: 'Change Log History',
  [ScreenKey.SETTINGS]: 'Settings',
  [ScreenKey.INSIGHTS]: 'Insights',
  [ScreenKey.SEGMENTS]: 'Segments',
  [ScreenKey.PDF_BUILDER]: 'PDF Builder',
  [ScreenKey.PARTNER_DATA_HEALTH]: 'Partner Data Health',
};

export const SCREEN_ROUTES: Record<ScreenKey, Route> = {
  [ScreenKey.REPORTING_DASHBOARD]: Route.REPORTING_DASHBOARD,
  [ScreenKey.REPORTING_V2]: Route.REPORTING_V2,
  [ScreenKey.CUSTOM_DASHBOARDS]: Route.CUSTOM_DASHBOARDS,
  [ScreenKey.USER_MANAGEMENT]: Route.USER_MANAGEMENT,
  [ScreenKey.PACING]: Route.PACING,
  [ScreenKey.FORECASTER]: Route.FORECASTER,
  [ScreenKey.FORECASTER_AI]: Route.FORECASTER_AI,
  [ScreenKey.CAMPAIGN_SUBMISSION]: Route.CAMPAIGN_SUBMISSION,
  [ScreenKey.REPORT_BUILDER]: Route.REPORT_BUILDER,
  [ScreenKey.CAMPAIGN_MANAGEMENT]: Route.CAMPAIGN_MANAGEMENT,
  [ScreenKey.CREATIVE_LIBRARY]: Route.CREATIVE_LIBRARY,
  [ScreenKey.PIXELS]: Route.PIXELS,
  [ScreenKey.WHITELABELS]: Route.WHITELABELS,
  [ScreenKey.ADVERTISERS]: Route.ADVERTISERS,
  [ScreenKey.AGENCIES]: Route.AGENCIES,
  [ScreenKey.FIRST_PARTY_DATA]: Route.FIRST_PARTY_DATA,
  [ScreenKey.CHANGE_LOG_HISTORY]: Route.CHANGE_LOG_HISTORY,
  [ScreenKey.CLIENTS]: Route.CLIENTS,
  [ScreenKey.INSIGHTS]: Route.INSIGHTS,
  [ScreenKey.FORECASTER_TABLE]: Route.FORECASTER_TABLE,
  [ScreenKey.CREATE_CAMPAIGN]: Route.CAMPAIGN_SUBMISSION,
  [ScreenKey.SETTINGS]: Route.SETTINGS,
  [ScreenKey.SEGMENTS]: Route.SEGMENTS,
  [ScreenKey.PDF_BUILDER]: Route.PDF_BUILDER,
  [ScreenKey.PARTNER_DATA_HEALTH]: Route.PARTNER_DATA_HEALTH,
};

export const SIDEBAR_SCREEN_LABELS: Record<ScreenKey, string> = {
  [ScreenKey.USER_MANAGEMENT]: 'User Management',
  [ScreenKey.REPORTING_DASHBOARD]: 'Reporting',
  [ScreenKey.REPORTING_V2]: 'Unified Reporting',
  [ScreenKey.CUSTOM_DASHBOARDS]: 'Custom Dashboards',
  [ScreenKey.REPORT_BUILDER]: 'Report Builder',
  [ScreenKey.PIXELS]: 'Pixels',
  [ScreenKey.PACING]: 'Pacing',
  [ScreenKey.FORECASTER]: 'Forecaster',
  [ScreenKey.CAMPAIGN_SUBMISSION]: 'Campaigns',
  [ScreenKey.CAMPAIGN_MANAGEMENT]: 'Campaigns',
  [ScreenKey.CREATIVE_LIBRARY]: 'Creative Library',
  [ScreenKey.WHITELABELS]: 'Whitelabels',
  [ScreenKey.ADVERTISERS]: 'Advertisers',
  [ScreenKey.AGENCIES]: 'Agencies',
  [ScreenKey.FIRST_PARTY_DATA]: 'First Party Data Upload',
  [ScreenKey.CHANGE_LOG_HISTORY]: 'Change Log History',
  [ScreenKey.CLIENTS]: 'Clients',
  [ScreenKey.INSIGHTS]: 'Insights',
  [ScreenKey.CREATE_CAMPAIGN]: 'Campaign Submission',
  [ScreenKey.FORECASTER_TABLE]: 'Saved Forecasts',
  [ScreenKey.FORECASTER_AI]: 'Forecaster AI',
  [ScreenKey.SETTINGS]: 'Settings',
  [ScreenKey.SEGMENTS]: 'Segments',
  [ScreenKey.PDF_BUILDER]: 'PDF Builder',
  [ScreenKey.PARTNER_DATA_HEALTH]: 'Partner Data Health',
};

/**
 * Where a signed-in user lands by default. Unified Reporting wins when held: the
 * backend hides the legacy dashboard from the nav for those users, so routing them
 * there would land them on a page they cannot navigate back to (ribeyemedia/ribeye-api#2217).
 */
export const resolveLandingRoute = (screens?: { name: ScreenKey }[]): Route => {
  if (screens?.some(screen => screen.name === ScreenKey.REPORTING_V2)) {
    return Route.REPORTING_V2;
  }
  if (!screens?.length || screens.some(screen => screen.name === ScreenKey.REPORTING_DASHBOARD)) {
    return Route.REPORTING_DASHBOARD;
  }
  return SCREEN_ROUTES[screens[0].name];
};
